module.exports = __webpack_public_path__ + "static/media/outgoing-shipments.d07e0e29.png";